export function getRegexEscapedString(str: string): string {
  return str
    .replace(/\./g, '\\.')
    .replace(/\+/g, '\\+')
    .replace(/\*/g, '\\*')
    .replace(/\?/g, '\\?')
    .replace(/\[/g, '\\[')
    .replace(/\^/g, '\\^')
    .replace(/\]/g, '\\]')
    .replace(/\$/g, '\\$')
    .replace(/\(/g, '\\(')
    .replace(/\)/g, '\\)')
    .replace(/\{/g, '\\{')
    .replace(/\}/g, '\\}')
    .replace(/\=/g, '\\=')
    .replace(/\!/g, '\\!')
    .replace(/\</g, '\\<')
    .replace(/\>/g, '\\>')
    .replace(/\|/g, '\\|')
    .replace(/\:/g, '\\:')
    .replace(/\-/g, '\\-');
}
